import { Box as MuiBox, styled } from '@material-ui/core';

export const Box = styled(MuiBox)({
  '& .MuiTypography-root': { margin: 0 },
  display: 'flex',
  alignItems: 'center',
  height: '100%',
});
